<template>
  <div class="container">
    <HeadingOne class="-margin-md">ご本人さま確認書類のご提出</HeadingOne>

    <MainWizard
      :active-index="3"
      type="useridentity"
      class="_mb-sm-35 _mb-md-50"
    ></MainWizard>

    <NoticeBox class="-success">
      <NoticeHeader>
        <h3 class="heading">
          ご本人さま確認書類のアップロードが完了しました。
        </h3>
      </NoticeHeader>
      <NoticeBody
        >お手続きが完了次第ご登録いただいたメールアドレスにご案内をお送りします。<br /><small
          >※反映には数日かかる場合がございます。</small
        ></NoticeBody
      >
    </NoticeBox>

    <BtngroupSingle class="-margin-lg">
      <BtnMain class="-main" router-name="mb001"
        >会員さま専用サイトトップへ</BtnMain
      >
    </BtngroupSingle>
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";
import HeadingOne from "@/components/heading/HeadingOne";
import MainWizard from "@/components/wizard/MainWizard";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeHeader from "@/components/box/NoticeHeader";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import NoticeBody from "@/components/box/NoticeBody";
export default {
  name: "Mb037",
  components: {
    NoticeBody,
    BtnMain,
    BtngroupSingle,
    NoticeHeader,
    NoticeBox,
    MainWizard,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "ご本人さま確認書類のご提出",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,本人確認書類",
    });
  },
  data() {
    return {};
  },
};
</script>

<style scoped></style>
